import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import FloatingActions from './components/FloatingActions';

import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Contact from './pages/Contact';
import KeralaAnalysis from './pages/KeralaAnalysis';
import SiteAudit from './pages/SiteAudit';
import TermsConditions from './pages/TermsConditions';
import PrivacyPolicy from './pages/PrivacyPolicy';

import GEO from './pages/services/GEO';
import AEO from './pages/services/AEO';
import AIO from './pages/services/AIO';
import CAO from './pages/services/CAO';
import LLMO from './pages/services/LLMO';
import GAIO from './pages/services/GAIO';
import AISO from './pages/services/AISO';
import SRO from './pages/services/SRO';
import QEO from './pages/services/QEO';
import GSO from './pages/services/GSO';
import RAO from './pages/services/RAO';
import AAO from './pages/services/AAO';

import './index.css';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="App">
          <ScrollToTop />
          <Navbar />
          <main style={{ paddingBottom: '0' }}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/kerala-analysis" element={<KeralaAnalysis />} />
              <Route path="/site-audit" element={<SiteAudit />} />
              <Route path="/terms-and-conditions" element={<TermsConditions />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/services/geo" element={<GEO />} />
              <Route path="/services/aeo" element={<AEO />} />
              <Route path="/services/aio" element={<AIO />} />
              <Route path="/services/cao" element={<CAO />} />
              <Route path="/services/llmo" element={<LLMO />} />
              <Route path="/services/gaio" element={<GAIO />} />
              <Route path="/services/aiso" element={<AISO />} />
              <Route path="/services/sro" element={<SRO />} />
              <Route path="/services/qeo" element={<QEO />} />
              <Route path="/services/gso" element={<GSO />} />
              <Route path="/services/rao" element={<RAO />} />
              <Route path="/services/aao" element={<AAO />} />
              <Route path="*" element={<Home />} />
            </Routes>
          </main>
          <Footer />
          <FloatingActions />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
